module.exports = __webpack_public_path__ + "img/result-detail-invest-inright01.dccdf330.svg";